import {
    FETCH_GAME_SETTINGS_REQUEST,
    FETCH_GAME_SETTINGS_SUCCESS,
    FETCH_GAME_SETTINGS_FAILURE,
    ADD_GAME_SETTINGS_SUCCESS,
    UPDATE_GAME_SETTINGS_SUCCESS
} from '../actions/settingsAction';


const initialState = {
    settings: [],
    sloading: false,
    serror: null
};

const settingsReducer = (state = initialState, action) => {
   
    switch (action.type) {
        case FETCH_GAME_SETTINGS_REQUEST:
            return {
                ...state,
                sloading: true,
                serror: null
            };
        case FETCH_GAME_SETTINGS_SUCCESS:
             console.log("settingsReducer",action.payload)
            return {
                ...state,
                sloading: true,
                settings: action.payload.data,
                serror: null
            };
        case FETCH_GAME_SETTINGS_FAILURE:
            return {
                ...state,
                sloading: false,
                serror: action.payload
            };
        default:
            return state;
    }
};

export default settingsReducer;